import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Box } from '../../../../../../../../CommonComponents/OPL/Box/Box';
import { FormComponentProps, FormFields, TabComponentProps } from '../../AccountForm.meta';
import { TabWrapper } from '../../AccountForm.styles';
import { AccountDescription } from '../../components/AccountDescription/AccountDescription';
import { AccountFees } from '../../components/AccountFees/AccountFees';
import { AccountOwnerSelect } from '../../components/AccountOwnerSelect/AccountOwnerSelect';
import { AccountTypeSelect } from '../../components/AccountTypeSelect/AccountTypeSelect';
import { AssetBucketing } from '../../components/AssetBucketing/AssetBucketing';
import { Balance } from '../../components/Balance/Balance';
import { BrokerOfRecord } from '../../components/BrokerOfRecord/BrokerOfRecord';
import { ContributionEndYearSelect } from '../../components/ContributionEndYearSelect/ContributionEndYearSelect';
import { ContributionStartYearSelect } from '../../components/ContributionStartYearSelect/ContributionStartYearSelect';
import { DistributionStrategySelect } from '../../components/DistributionStrategy/DistributionStrategySelect';
import { InstitutionNameInput } from '../../components/InstitutionNameInput/InstitutionNameInput';
import { IsSpouseSingleBeneficiary } from '../../components/IsSpouseSingleBeneficiary/IsSpouseSingleBeneficiary';
import { TabsContent } from '../../components/TabsContent/TabsContent';
import { Liquidity } from '../../components/Liquidity/Liquidity';
import { GrossEstateCheckbox } from '../../components/GrossEstateCheckbox/GrossEstateCheckbox';
import { CompanyOwnership } from '../../components/CompanyOwnership/CompanyOwnership';
import { EmployerMatch } from '../../components/EmployerMatch/EmployerMatch';
import { PercentageUsedInPlan } from '../../components/PercentageUsedInPlan/PercentageUsedInPlan';
import { TaxStatus } from '../../components/TaxStatus/TaxStatus';
import { ManagementStyle } from '../../components/ManagementStyle/ManagementStyle';
import { AccountType } from '../../../../../../api/useAccountsOptionsQuery';
import { AccountNickname } from '../../components/AccountNickname/AccountNickname';

const Summary = () => {
  const { watch } = useFormContext<FormFields>();
  const taxStatus = watch('bankAccount.TaxStatus');

  return (
    <TabWrapper>
      <AccountTypeSelect />
      <InstitutionNameInput />
      <AccountOwnerSelect />
      <AccountDescription />
      <AccountNickname />
      <Balance label="Current Market Value" />
      <ManagementStyle />
      {taxStatus === null && <AssetBucketing />}
      <TaxStatus />
      <Liquidity />
      <GrossEstateCheckbox />
      <BrokerOfRecord />
    </TabWrapper>
  );
};

const AccountDetails = ({ accountType }: TabComponentProps) => {
  return (
    <TabWrapper>
      <Box
        css={`
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 16px;
        `}
      >
        <ContributionStartYearSelect />
        <ContributionEndYearSelect />
      </Box>

      <DistributionStrategySelect />
      <AccountFees />
      <IsSpouseSingleBeneficiary />
      <PercentageUsedInPlan />

      {accountType !== AccountType.Roth401K && <CompanyOwnership />}
    </TabWrapper>
  );
};

export const FourHundredK = (props: FormComponentProps) => {
  return (
    <TabsContent
      {...props}
      tabs={[
        { name: 'Summary', Component: Summary },
        { name: 'Contributions', Component: EmployerMatch },
        { name: 'Account Details', Component: AccountDetails },
      ]}
    />
  );
};
